import { Box as MaterialSpacer } from '@mui/material';
import React from 'react';

export type SpacerProps = {
  margin?: 'text' | 'normal' | 'large';
};
export const DEFAULT_MARGIN_TEXT = { xs: 5, sm: 5, md: 5, lg: 6 };
export const DEFAULT_MARGIN_NORMAL = { xs: 5, sm: 6, md: 6, lg: 9 };
export const DEFAULT_MARGIN_LARGE = { xs: 9, sm: 9, md: 10, lg: 12 };

export const Spacer: React.FC<SpacerProps> = ({ margin = 'normal' }) => {
  switch (margin) {
    case 'text':
      return <MaterialSpacer my={DEFAULT_MARGIN_TEXT} />;
    case 'normal':
      return <MaterialSpacer my={DEFAULT_MARGIN_NORMAL} />;
    case 'large':
      return <MaterialSpacer my={DEFAULT_MARGIN_LARGE} />;
  }
};
